import { UserReviewSummary } from '../../types';

export type StoreLinkClickProps = {
  id: number;
  name: string;
  featured: boolean;
  userReviewSummary: UserReviewSummary;
};

export type ReviewFilterOption = {
  title: string;
  value?: string | number;
  distribution?: number | null;
};

export enum RouteSection {
  REVIEWS = 'reviews',
  MAIN = 'main',
}

export type AnalyticsStore = {
  id: number;
  name: string;
  url: string;
};

export enum TabAnchor {
  REVIEWS = '#reviews',
  ABOUT = '#about',
}

export type NoResultTranslationKey =
  | 'rating.option-terrible-no-result'
  | 'rating.option-bad-no-result'
  | 'rating.option-ok-no-result'
  | 'rating.option-good-no-result'
  | 'rating.option-excellent-no-result';
